



























































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PolicyDataInfo } from '../../utils';

@Component
export default class PrivacyPolicyEnFirst extends Vue {
    @Prop({ type: Object, required: true}) private formData!: PolicyDataInfo
    isShow = false
    public mounted() {
        console.log('formData',this.formData)
        this.isShow = window.location.href.indexOf('ucloud.akuvox.com') > -1||process.env.NODE_ENV === 'development' || window.location.href.indexOf('test84.akuvox') > -1
    }
}
